import { CurdDataSetConfig, FormFieldType, Geofence } from '../types';
import { toDateFormat } from '@mri/functions';
import { propertyCommonField } from './property-common-field';

export const geofenceDataSetConfig: CurdDataSetConfig<Geofence> = {
  entityName: 'Geocerca',
  collectionName: 'Geofences',
  gatewayUrl: 'geofences',
  baseBreadcrumb: 'geofences',
  form: {
    listRedirectUrl: 'console/geofences/list',
    fields: [
      {
        key: 'name',
        label: 'Nombre',
        type: FormFieldType.STRING,
        containerClass: 'col-12',
      },
      {
        key: 'description',
        label: 'Descripción',
        type: FormFieldType.STRING,
        containerClass: 'col-12'
      },
      {
        key: 'geometric',
        label: 'Geocerca',
        type: FormFieldType.GEO_JSON,
        containerClass: 'col-12'
      },
      propertyCommonField
    ]
  },
  list: {
    pageConfig: {
      title: 'Lista de geocercas',
      breadcrumb: [
        {
          title: 'Geocercas',
          type: 'item',
          link: 'console/geofences/list',
        },
        {
          title: 'Lista',
          type: 'item',
          pageName: 'Geocercas'
        }
      ]
    },
    table: {
      columns: [
        { key: 'name', label: 'Nombre' },
        { key: 'description', label: 'Descripcion' },
        { key: 'owner', label: 'Dueño', getValue:  ({ element }) => element.property?.name || 'No definido' },
        { key: 'createTime', label: 'Fecha de creación', getValue:  ({ element }) => toDateFormat(element.createdTime) }
      ]
    },
    actionsKeys: ['create', 'edit', 'transfer', 'delete'],
    filter: [
      {
        key: 'Nombre',
        label: 'name',
        type: FormFieldType.STRING
      },
      {
        key: 'propertyId',
        label: 'Propietario',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsGateway: 'properties'
      }
    ]
  },
  pages: ['list', 'create', 'edit'],
};
